import {takeEvery} from 'redux-saga/effects'
import {
  ADD_BOOK,
  ADD_BOOK_RESERVATION,
  ADD_CATEGORY,
  ADD_SUBJECT,
  BOOK_RETURN,
  DELETE_BOOK,
  DELETE_BOOKS,
  DELETE_BOOK_RESERVATION,
  DELETE_CATEGORY,
  DELETE_SUBJECT,
  FILE_UPLOAD_BOOK,
  GET_ACTIVE_BOOKS,
  GET_ACTIVE_CATEGORIES,
  GET_ACTIVE_SUBJECTS,
  GET_BOOK,
  GET_BOOKS,
  GET_BOOK_RENEWAL_REQUEST,
  GET_BOOK_RESERVATION,
  GET_BOOK_RESERVATIONS,
  GET_BOOK_RESERVATIONS_HISTORY,
  GET_BOOK_SETTING,
  GET_BOOK_SETTINGS,
  GET_BOOK_SUBJECT,
  GET_BOOK_SUBJECTS,
  GET_CATEGORIES,
  GET_CATEGORY,
  GET_USER_RESERVATIONS,
  LIBRARY_STATS,
  SEND_MAIL_RESERVATION,
  UPDATE_BOOK,
  UPDATE_BOOK_RENEWAL_REQUEST,
  UPDATE_BOOK_RESERVATION,
  UPDATE_BOOK_SETTING,
  UPDATE_BOOK_STATUS,
  UPDATE_CATEGORY,
  UPDATE_SUBJECT,
} from 'setup/redux/Actions/Library/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  // Category
  yield takeEvery(GET_CATEGORIES, fetchData)
  yield takeEvery(GET_ACTIVE_CATEGORIES, fetchData)
  yield takeEvery(GET_CATEGORY, fetchData)
  yield takeEvery(ADD_CATEGORY, fetchData)
  yield takeEvery(UPDATE_CATEGORY, fetchData)
  yield takeEvery(DELETE_CATEGORY, fetchData)

  // Subject
  yield takeEvery(GET_BOOK_SUBJECTS, fetchData)
  yield takeEvery(GET_ACTIVE_SUBJECTS, fetchData)
  yield takeEvery(GET_BOOK_SUBJECT, fetchData)
  yield takeEvery(ADD_SUBJECT, fetchData)
  yield takeEvery(UPDATE_SUBJECT, fetchData)
  yield takeEvery(DELETE_SUBJECT, fetchData)

  // Book
  yield takeEvery(GET_BOOKS, fetchData)
  yield takeEvery(GET_ACTIVE_BOOKS, fetchData)
  yield takeEvery(GET_BOOK, fetchData)
  yield takeEvery(ADD_BOOK, fetchData)
  yield takeEvery(UPDATE_BOOK, fetchData)
  yield takeEvery(UPDATE_BOOK_STATUS, fetchData)
  yield takeEvery(DELETE_BOOK, fetchData)
  yield takeEvery(DELETE_BOOKS, fetchData)

  yield takeEvery(FILE_UPLOAD_BOOK, fetchData)

  // Book Reservation
  yield takeEvery(GET_BOOK_RESERVATIONS, fetchData)
  yield takeEvery(GET_BOOK_RESERVATIONS_HISTORY, fetchData)

  yield takeEvery(GET_BOOK_RESERVATION, fetchData)
  yield takeEvery(ADD_BOOK_RESERVATION, fetchData)
  yield takeEvery(UPDATE_BOOK_RESERVATION, fetchData)
  yield takeEvery(DELETE_BOOK_RESERVATION, fetchData)

  yield takeEvery(BOOK_RETURN, fetchData)

  yield takeEvery(SEND_MAIL_RESERVATION, fetchData)

  yield takeEvery(GET_USER_RESERVATIONS, fetchData)

  // Setting
  yield takeEvery(GET_BOOK_SETTINGS, fetchData)
  yield takeEvery(GET_BOOK_SETTING, fetchData)
  yield takeEvery(UPDATE_BOOK_SETTING, fetchData)

  // Renewal Request
  yield takeEvery(GET_BOOK_RENEWAL_REQUEST, fetchData)
  yield takeEvery(UPDATE_BOOK_RENEWAL_REQUEST, fetchData)

  yield takeEvery(LIBRARY_STATS, fetchData)
}

export default dataSaga
